module.exports = {
  'bp-small': '480px',
  'bp-mobile': '740px',
  'bp-tablet': '1080px',
  'bp-desktop': '1280px',
  'bp-desktop-l': '1440px'
}



// WEBPACK FOOTER //
// ./src/vars/breakpoints.js